import { useController } from "react-hook-form";
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import { CheckboxField, CheckboxOption } from "./CheckboxField";

type FormCheckboxProps = {
    alignTop?: boolean;
    defaultValue?: boolean | string | string[];
    helperText?: string;
    label?: string;
    labelPlacement?: "end" | "start";
    name: string;
} & (
    | {
          options: [CheckboxOption];
      }
    | {
          options: CheckboxOption[];
      }
);

export function FormCheckbox({
    alignTop,
    defaultValue,
    helperText,
    label,
    labelPlacement,
    name,
    options,
}: FormCheckboxProps) {
    const isSingleOption = options.length === 1;

    let fallbackValue: boolean | string | string[];

    if (defaultValue !== undefined) {
        fallbackValue = defaultValue;
    } else if (isSingleOption) {
        const isBoolean = typeof options[0].value === "boolean";
        fallbackValue = isBoolean ? false : "";
    } else {
        fallbackValue = [];
    }

    const { field, fieldState } = useController({
        name,
        defaultValue: fallbackValue,
    });

    return (
        <FieldWrapper name={field.name}>
            <CheckboxField
                alignTop={alignTop}
                helperText={helperText}
                inputRef={field.ref}
                isError={!!fieldState.error}
                label={label}
                labelPlacement={labelPlacement}
                name={field.name}
                onChange={field.onChange}
                options={options}
                value={field.value}
            />
        </FieldWrapper>
    );
}
